import React from "react"
import { Layout } from "antd"
import styles from "./index.module.css"
import { Outlet, useLocation } from "react-router-dom"
import { ResourcesBreadcrumb } from "./BreadCrumb"
import classNames from "classnames"
import { useDevice } from "hooks/useDevice"

export const ProResourcesLayout = () => {
  const location = useLocation()
  const { isMobile } = useDevice()

  // Check if on equipment edit/add/duplicate routes or crew edit route
  const isEquipmentFormRoute =
    location.pathname.includes("/resources/equipment/") &&
    (location.pathname.endsWith("/edit") ||
     location.pathname.endsWith("/add") ||
     location.pathname.endsWith("/duplicate"))

  const isCrewEditRoute = location.pathname.includes("/resources/crew/edit/")

  // Hide breadcrumb on mobile when form is open
  const shouldHideBreadcrumb = isMobile && (isEquipmentFormRoute || isCrewEditRoute)

  return (
    <Layout className={classNames(styles.layout)}>
      {!shouldHideBreadcrumb && <ResourcesBreadcrumb />}
      <Outlet />
    </Layout>
  )
}
